module.exports = __webpack_public_path__ + "img/head_img.b14bb37c.jpg";